/**
 * Product fee extensions: single `extension` object and/or `extensions[]`.
 * { value, type: "fee", enabled: 1, calculation_type: "fixed", ... }
 */
export function normalizeProductExtensions(product) {
    if (!product || typeof product !== 'object') return [];
    const out = [];
    if (Array.isArray(product.extensions)) {
        out.push(...product.extensions.filter((x) => x && typeof x === 'object'));
    }
    const single = product.extension;
    if (single && typeof single === 'object' && !Array.isArray(single)) {
        out.push(single);
    }
    return out;
}

function isExtensionEnabled(ext) {
    const e = ext?.enabled;
    return e === 1 || e === true || e === '1';
}

export function getProductServiceFee(product) {
    let sum = 0;
    for (const ext of normalizeProductExtensions(product)) {
        if (!isExtensionEnabled(ext)) continue;
        if (String(ext.type || '').toLowerCase() !== 'fee') continue;
        const calc = String(ext.calculation_type || ext.calculationType || 'fixed').toLowerCase();
        if (calc && calc !== 'fixed') continue;
        const v = Number(ext.value);
        if (!Number.isNaN(v) && v > 0) sum += v;
    }
    return Math.round(sum * 100) / 100;
}

export function getProductBasePrice(product) {
    return Number(product?.price) || 0;
}

/** Base vignette price + enabled fixed service fees */
export function getProductTotalWithFees(product) {
    return Math.round((getProductBasePrice(product) + getProductServiceFee(product)) * 100) / 100;
}

export function formatPriceAmount(amount, maxDecimals = 2) {
    const value = Number(amount) || 0;
    return value.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDecimals,
    });
}
